"use strict";

// =====================================================
// REPORTES IGSS
//
// Archivo:
// src/fronend/reportes/igss/reportesigss.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosreportesigss = [];


// =====================================================
// ELEMENTOS HTML
// =====================================================

const tbodyreportesigss =
    document.getElementById("tbodyreportesigss");

const buscarIGSS =
    document.getElementById("buscarIGSS");

const btnLimpiarBusqueda =
    document.getElementById("btnLimpiarBusqueda");

const btnPDFIGSS =
    document.getElementById("btnPDFIGSS");

const totalEmpleados =
    document.getElementById("totalEmpleados");

const porcentajeIGSS =
    document.getElementById("porcentajeIGSS");

const totalPagadoIGSS =
    document.getElementById("totalPagadoIGSS");


// =====================================================
// FORMATO MONEDA
// =====================================================

function formatoMoneda(valor) {

    const numero =
        Number(valor) || 0;

    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );
}


// =====================================================
// FORMATO FECHA
// =====================================================

function formatoFecha(fecha) {

    if (!fecha) {
        return "";
    }

    const fechaObjeto =
        new Date(fecha);

    if (
        isNaN(
            fechaObjeto.getTime()
        )
    ) {

        return fecha;
    }

    return fechaObjeto.toLocaleDateString(
        "es-GT",
        {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }
    );
}


// =====================================================
// OBTENER INICIALES
// =====================================================

function obtenerIniciales(nombre) {

    if (!nombre) {
        return "?";
    }

    const palabras =
        nombre
            .trim()
            .split(/\s+/)
            .filter(Boolean);

    if (palabras.length === 1) {

        return palabras[0]
            .substring(0, 2)
            .toUpperCase();
    }

    return (
        palabras[0].charAt(0) +
        palabras[1].charAt(0)
    ).toUpperCase();
}


// =====================================================
// OBTENER DESCUENTO IGSS
// =====================================================
//
// Acepta:
//
// DESCUENTO APLICADO IGSS
//
// y también:
//
// DESCUENTO APLICADO IGGS
//
// Esto evita problemas si la vista anterior todavía
// tiene el alias IGGS.
// =====================================================

function obtenerDescuentoIGSS(registro) {

    if (
        registro[
            "DESCUENTO APLICADO IGSS"
        ] !== undefined &&
        registro[
            "DESCUENTO APLICADO IGSS"
        ] !== null
    ) {

        return Number(
            registro[
                "DESCUENTO APLICADO IGSS"
            ]
        ) || 0;
    }


    if (
        registro[
            "DESCUENTO APLICADO IGGS"
        ] !== undefined &&
        registro[
            "DESCUENTO APLICADO IGGS"
        ] !== null
    ) {

        return Number(
            registro[
                "DESCUENTO APLICADO IGGS"
            ]
        ) || 0;
    }


    return 0;
}


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

function actualizarResumen() {

    // -------------------------------------------------
    // TOTAL EMPLEADOS
    // -------------------------------------------------

    if (totalEmpleados) {

        totalEmpleados.textContent =
            registrosreportesigss.length;
    }


    // -------------------------------------------------
    // PORCENTAJE IGSS
    // -------------------------------------------------

    let porcentaje = 0;

    if (
        registrosreportesigss.length > 0
    ) {

        const porcentajes =
            registrosreportesigss

                .map(
                    registro =>
                        Number(
                            registro.IGSS
                        ) || 0
                )

                .filter(
                    valor => valor > 0
                );


        if (porcentajes.length > 0) {

            porcentaje =
                porcentajes.reduce(
                    (
                        total,
                        valor
                    ) =>
                        total + valor,
                    0
                ) /
                porcentajes.length;
        }
    }


    if (porcentajeIGSS) {

        porcentajeIGSS.textContent =
            `${porcentaje.toFixed(2)} %`;
    }


    // -------------------------------------------------
    // TOTAL DESCUENTO IGSS
    // -------------------------------------------------

    const total =
        registrosreportesigss.reduce(
            (
                acumulado,
                registro
            ) => {

                return acumulado +
                    obtenerDescuentoIGSS(
                        registro
                    );
            },
            0
        );


    if (totalPagadoIGSS) {

        totalPagadoIGSS.textContent =
            `Q ${formatoMoneda(total)}`;
    }
}


// =====================================================
// MOSTRAR CARGANDO
// =====================================================

function mostrarCargando() {

    if (!tbodyreportesigss) {

        console.error(
            "No se encontró #tbodyreportesigss."
        );

        return;
    }


    tbodyreportesigss.innerHTML = `

        <tr>

            <td
                colspan="9"
                class="loading text-center py-4"
            >

                <div
                    class="spinner-border text-success me-2"
                    role="status"
                ></div>

                Cargando reporte de IGSS...

            </td>

        </tr>

    `;
}


// =====================================================
// MOSTRAR TABLA VACÍA
// =====================================================

function mostrarTablaVacia() {

    if (!tbodyreportesigss) {
        return;
    }


    tbodyreportesigss.innerHTML = `

        <tr>

            <td
                colspan="9"
                class="empty-state text-center py-4"
            >

                <i
                    class="bi bi-file-earmark-medical d-block fs-1"
                ></i>

                <strong>
                    No hay registros de IGSS
                </strong>

                <div class="mt-2">

                    No se encontraron empleados
                    para mostrar.

                </div>

            </td>

        </tr>

    `;
}


// =====================================================
// MOSTRAR ERROR
// =====================================================

function mostrarError(mensaje) {

    if (!tbodyreportesigss) {
        return;
    }


    tbodyreportesigss.innerHTML = `

        <tr>

            <td
                colspan="9"
                class="empty-state text-danger text-center py-4"
            >

                <i
                    class="bi bi-exclamation-triangle d-block text-danger fs-1"
                ></i>

                <strong>
                    Error al cargar el reporte
                </strong>

                <div class="mt-2">

                    ${mensaje}

                </div>

            </td>

        </tr>

    `;
}


// =====================================================
// RENDERIZAR TABLA
// =====================================================

function renderizarTabla() {

    if (!tbodyreportesigss) {

        console.error(
            "No se encontró el elemento #tbodyreportesigss en el HTML."
        );

        return;
    }


    tbodyreportesigss.innerHTML = "";


    // -------------------------------------------------
    // SIN REGISTROS
    // -------------------------------------------------

    if (
        !Array.isArray(
            registrosreportesigss
        ) ||
        registrosreportesigss.length === 0
    ) {

        mostrarTablaVacia();

        actualizarResumen();

        return;
    }


    // -------------------------------------------------
    // RECORRER REGISTROS
    // -------------------------------------------------

    registrosreportesigss.forEach(
        (
            registro,
            indice
        ) => {


            // -----------------------------------------
            // DATOS
            // -----------------------------------------

            const nombre =
                registro.NOMBREEMPLEADO || "";


            const dpi =
                registro.DPI || "";


            const puesto =
                registro.NOMBREPUESTO || "";


            const departamento =
                registro.NOMBRETECNOLOGICO || "";


            const salarioBase =
                Number(
                    registro.SALARIOBASE
                ) || 0;


            const igss =
                Number(
                    registro.IGSS
                ) || 0;


            const descuento =
                obtenerDescuentoIGSS(
                    registro
                );


            const fecha =
                formatoFecha(
                    registro.FECHA
                );


            // -----------------------------------------
            // CREAR FILA
            // -----------------------------------------

            const fila =
                document.createElement("tr");


            fila.innerHTML = `

                <td>
                    ${indice + 1}
                </td>


                <td>

                    <div
                        class="d-flex align-items-center"
                    >

                        <span
                            class="employee-avatar"
                        >

                            ${obtenerIniciales(
                                nombre
                            )}

                        </span>


                        <span
                            class="employee-name"
                        >

                            ${nombre}

                        </span>

                    </div>

                </td>


                <td>
                    ${dpi}
                </td>


                <td>
                    ${puesto}
                </td>


                <td>
                    ${departamento}
                </td>


                <td>

                    <span
                        class="salary"
                    >

                        Q ${formatoMoneda(
                            salarioBase
                        )}

                    </span>

                </td>


                <td>

                    <span
                        class="igss"
                    >

                        ${igss.toFixed(2)} %

                    </span>

                </td>


                <td>

                    <span
                        class="pago-igss"
                    >

                        Q ${formatoMoneda(
                            descuento
                        )}

                    </span>

                </td>


                <td>
                    ${fecha}
                </td>

            `;


            tbodyreportesigss.appendChild(
                fila
            );

        }
    );


    // -------------------------------------------------
    // ACTUALIZAR RESUMEN
    // -------------------------------------------------

    actualizarResumen();
}


// =====================================================
// LISTAR REPORTE IGSS
// =====================================================

async function listarReporteIGSS() {

    try {

        mostrarCargando();


        const respuesta =
            await fetch(
                "/reportes/igss/listar"
            );


        console.log(
            "Estado HTTP IGSS:",
            respuesta.status
        );


        if (!respuesta.ok) {

            let mensaje =
                "No se pudo obtener el reporte de IGSS.";


            try {

                const error =
                    await respuesta.json();


                if (error.mensaje) {

                    mensaje =
                        error.mensaje;
                }


                if (error.error) {

                    mensaje +=
                        ` ${error.error}`;
                }

            } catch (e) {

                console.error(
                    "No se pudo leer el error del servidor:",
                    e
                );
            }


            throw new Error(
                mensaje
            );
        }


        const datos =
            await respuesta.json();


        console.log(
            "Reporte IGSS recibido:",
            datos
        );


        if (!Array.isArray(datos)) {

            throw new Error(
                "El servidor no devolvió una lista válida de registros."
            );
        }


        registrosreportesigss =
            datos;


        renderizarTabla();


    } catch (error) {

        console.error(
            "Error al cargar reporte IGSS:",
            error
        );


        registrosreportesigss =
            [];


        mostrarError(
            error.message ||
            "No se pudo obtener el reporte de IGSS."
        );


        actualizarResumen();
    }
}


// =====================================================
// BUSCAR REPORTE IGSS
// =====================================================

async function buscarReporteIGSS(texto) {

    try {

        const valor =
            String(texto || "").trim();


        // -------------------------------------------------
        // SI ESTÁ VACÍO
        // -------------------------------------------------

        if (!valor) {

            await listarReporteIGSS();

            return;
        }


        mostrarCargando();


        const respuesta =
            await fetch(
                `/reportes/igss/buscar/${encodeURIComponent(valor)}`
            );


        console.log(
            "Estado HTTP búsqueda IGSS:",
            respuesta.status
        );


        if (!respuesta.ok) {

            let mensaje =
                "No se pudo realizar la búsqueda.";


            try {

                const error =
                    await respuesta.json();


                if (error.mensaje) {

                    mensaje =
                        error.mensaje;
                }


                if (error.error) {

                    mensaje +=
                        ` ${error.error}`;
                }

            } catch (e) {

                console.error(
                    "No se pudo leer el error del servidor:",
                    e
                );
            }


            throw new Error(
                mensaje
            );
        }


        const datos =
            await respuesta.json();


        console.log(
            "Resultado búsqueda IGSS:",
            datos
        );


        if (!Array.isArray(datos)) {

            throw new Error(
                "El servidor no devolvió una lista válida."
            );
        }


        registrosreportesigss =
            datos;


        renderizarTabla();


    } catch (error) {

        console.error(
            "Error al buscar reporte IGSS:",
            error
        );


        registrosreportesigss =
            [];


        mostrarError(
            error.message ||
            "No se pudo realizar la búsqueda."
        );


        actualizarResumen();
    }
}


// =====================================================
// BUSCADOR
// =====================================================

if (buscarIGSS) {

    let temporizadorBusqueda;


    buscarIGSS.addEventListener(
        "input",
        function () {

            clearTimeout(
                temporizadorBusqueda
            );


            temporizadorBusqueda =
                setTimeout(
                    () => {

                        buscarReporteIGSS(
                            this.value
                        );

                    },
                    300
                );

        }
    );
}


// =====================================================
// BOTÓN LIMPIAR
// =====================================================

if (btnLimpiarBusqueda) {

    btnLimpiarBusqueda.addEventListener(
        "click",
        async function () {

            if (buscarIGSS) {

                buscarIGSS.value =
                    "";
            }


            await listarReporteIGSS();


            if (buscarIGSS) {

                buscarIGSS.focus();
            }

        }
    );
}


// =====================================================
// CARGAR jsPDF
// =====================================================

function cargarJsPDF() {

    return new Promise(
        (
            resolve,
            reject
        ) => {


            // -----------------------------------------
            // YA ESTÁ CARGADO
            // -----------------------------------------

            if (
                window.jspdf &&
                window.jspdf.jsPDF
            ) {

                resolve();

                return;
            }


            // -----------------------------------------
            // CREAR SCRIPT
            // -----------------------------------------

            const script =
                document.createElement(
                    "script"
                );


            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";


            script.onload =
                () => {

                    resolve();
                };


            script.onerror =
                () => {

                    reject(
                        new Error(
                            "No se pudo cargar la librería PDF."
                        )
                    );
                };


            document.head.appendChild(
                script
            );

        }
    );
}


// =====================================================
// CARGAR AUTOTABLE
// =====================================================

function cargarAutoTable() {

    return new Promise(
        (
            resolve,
            reject
        ) => {


            // -----------------------------------------
            // YA ESTÁ CARGADO
            // -----------------------------------------

            if (
                window.jspdf &&
                window.jspdf.jsPDF &&
                window.jspdf.jsPDF.API &&
                window.jspdf.jsPDF.API.autoTable
            ) {

                resolve();

                return;
            }


            // -----------------------------------------
            // CREAR SCRIPT
            // -----------------------------------------

            const script =
                document.createElement(
                    "script"
                );


            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js";


            script.onload =
                () => {

                    resolve();
                };


            script.onerror =
                () => {

                    reject(
                        new Error(
                            "No se pudo cargar el complemento PDF."
                        )
                    );
                };


            document.head.appendChild(
                script
            );

        }
    );
}


// =====================================================
// GENERAR PDF IGSS
// =====================================================

async function generarPDFIGSS() {

    try {


        // -----------------------------------------
        // VALIDAR DATOS
        // -----------------------------------------

        if (
            !registrosreportesigss ||
            registrosreportesigss.length === 0
        ) {

            alert(
                "No hay registros de IGSS para generar el PDF."
            );

            return;
        }


        // -----------------------------------------
        // CARGAR LIBRERÍAS
        // -----------------------------------------

        await cargarJsPDF();

        await cargarAutoTable();


        // -----------------------------------------
        // CREAR DOCUMENTO
        // -----------------------------------------

        const {
            jsPDF
        } = window.jspdf;


        const doc =
            new jsPDF(
                "landscape",
                "mm",
                "letter"
            );


        // -----------------------------------------
        // ENCABEZADO
        // -----------------------------------------

        doc.setFontSize(
            18
        );


        doc.setFont(
            "helvetica",
            "bold"
        );


        doc.text(
            "CONSULTING S.A.",
            14,
            15
        );


        doc.setFontSize(
            14
        );


        doc.text(
            "REPORTE DE IGSS DE EMPLEADOS",
            14,
            24
        );


        doc.setFontSize(
            9
        );


        doc.setFont(
            "helvetica",
            "normal"
        );


        doc.text(
            "Reporte de salarios base y descuentos aplicados por IGSS",
            14,
            31
        );


        // -----------------------------------------
        // FECHA
        // -----------------------------------------

        const fechaActual =
            new Date().toLocaleDateString(
                "es-GT",
                {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }
            );


        doc.text(
            `Fecha de generación: ${fechaActual}`,
            14,
            38
        );


        // -----------------------------------------
        // TOTAL DESCUENTO IGSS
        // -----------------------------------------

        const total =
            registrosreportesigss.reduce(
                (
                    acumulado,
                    registro
                ) => {

                    return acumulado +
                        obtenerDescuentoIGSS(
                            registro
                        );

                },
                0
            );


        // -----------------------------------------
        // RESUMEN PDF
        // -----------------------------------------

        doc.setFont(
            "helvetica",
            "bold"
        );


        doc.text(
            `Empleados: ${registrosreportesigss.length}`,
            14,
            46
        );


        doc.text(
            `Total descuento IGSS: Q ${formatoMoneda(total)}`,
            70,
            46
        );


        // -----------------------------------------
        // FILAS PDF
        // -----------------------------------------

        const filas =
            registrosreportesigss.map(
                (
                    registro,
                    indice
                ) => {

                    return [

                        indice + 1,

                        registro.NOMBREEMPLEADO || "",

                        registro.DPI || "",

                        registro.NOMBREPUESTO || "",

                        registro.NOMBRETECNOLOGICO || "",

                        `Q ${formatoMoneda(
                            registro.SALARIOBASE
                        )}`,

                        `${(
                            Number(
                                registro.IGSS
                            ) || 0
                        ).toFixed(2)} %`,

                        `Q ${formatoMoneda(
                            obtenerDescuentoIGSS(
                                registro
                            )
                        )}`,

                        formatoFecha(
                            registro.FECHA
                        )

                    ];

                }
            );


        // -----------------------------------------
        // TABLA PDF
        // -----------------------------------------

        doc.autoTable({

            startY: 52,

            head: [[

                "#",

                "Empleado",

                "DPI",

                "Puesto",

                "Departamento Tecnológico",

                "Salario Base",

                "IGSS",

                "Descuento Aplicado IGSS",

                "Fecha"

            ]],


            body: filas,


            theme: "grid",


            styles: {

                fontSize: 7,

                cellPadding: 2,

                valign: "middle"

            },


            headStyles: {

                fontStyle: "bold"

            },


            columnStyles: {

                0: {
                    cellWidth: 8
                },

                1: {
                    cellWidth: 35
                },

                2: {
                    cellWidth: 28
                },

                3: {
                    cellWidth: 32
                },

                4: {
                    cellWidth: 42
                },

                5: {
                    cellWidth: 25
                },

                6: {
                    cellWidth: 18
                },

                7: {
                    cellWidth: 32
                },

                8: {
                    cellWidth: 22
                }

            },


            margin: {

                left: 10,

                right: 10

            }

        });


        // =================================================
        // PIE DE PÁGINA
        // =================================================

        const paginas =
            doc.internal.getNumberOfPages();


        for (
            let pagina = 1;
            pagina <= paginas;
            pagina++
        ) {

            doc.setPage(
                pagina
            );


            const alto =
                doc.internal.pageSize.height;


            doc.setFontSize(
                8
            );


            doc.setFont(
                "helvetica",
                "normal"
            );


            doc.text(
                `Página ${pagina} de ${paginas}`,
                14,
                alto - 8
            );


            doc.text(
                "Consulting S.A. - Sistema de Nóminas",
                200,
                alto - 8
            );

        }


        // =================================================
        // NOMBRE DEL ARCHIVO
        // =================================================

        const fechaArchivo =
            fechaActual.replace(
                /\//g,
                "-"
            );


        // =================================================
        // DESCARGAR PDF
        // =================================================

        doc.save(
            `Reporte_IGSS_${fechaArchivo}.pdf`
        );


    } catch (error) {

        console.error(
            "Error al generar PDF IGSS:",
            error
        );


        alert(
            "No fue posible generar el PDF."
        );

    }
}


// =====================================================
// BOTÓN PDF
// =====================================================

if (btnPDFIGSS) {

    btnPDFIGSS.addEventListener(
        "click",
        generarPDFIGSS
    );
}


// =====================================================
// INICIAR
// =====================================================

document.addEventListener(
    "DOMContentLoaded",
    function () {

        listarReporteIGSS();

    }
);